import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClinicSuppliesDefaultPage } from './clinic-supplies-default';

@NgModule({
  declarations: [
    ClinicSuppliesDefaultPage,
  ],
  imports: [
    IonicPageModule.forChild(ClinicSuppliesDefaultPage),
  ],
})
export class ClinicSuppliesDefaultPageModule {}



// WEBPACK FOOTER //
// ./src/pages/clinic-supplies-default/clinic-supplies-default.module.ts